export default "__VITE_ASSET__b8057ae0__"